import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Alert } from 'react-bootstrap';
import Loading from '../common/Loading';
import EmailPreview from './EmailPreview';
import SmsPreview from './SmsPreview';
import { CampaignStatusBadge } from './campaignDetailUtils';
import { useCampaign } from './useCampaign';
import { toProperCase } from '../process/processQueueUtils';
function CampaignPreview() {
    const { campaignId } = useParams();
    const { campaign, isLoading, error, refetch } = useCampaign(campaignId);

    const isSms = campaign?.type === 'SMS';

    return (
        <div className="container-fluid">
            <div className="pagetitle d-flex flex-wrap align-items-center justify-content-between gap-2">
                <h1 className="mb-0">
                    <i className="bi bi-eye me-2"></i>
                    Campaign Preview
                </h1>
                <div className="d-flex align-items-center gap-2">
                    <Link to="/campaign" className="campaign-queue-page__back d-inline-flex align-items-center gap-1">
                        <i className="bi bi-arrow-left"></i>
                        Back to campaigns
                    </Link>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={refetch}
                        disabled={isLoading}
                    >
                        <i className="bi bi-arrow-clockwise me-1"></i>
                        Refresh
                    </Button>
                </div>
            </div>

            {isLoading ? (
                <Loading />
            ) : error ? (
                <Alert variant="warning">{error}</Alert>
            ) : (
                campaign && (
                    <>
                        <div className="campaign-queue-context p-3 p-md-4 mb-3">
                            <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
                                <div className="flex-grow-1">
                                    <div className="text-muted small mb-1">{campaign.clinicName || '—'}</div>
                                    <div className="campaign-queue-context__title fw-semibold mb-1">
                                        {campaign.name || 'Untitled campaign'}
                                    </div>
                                    {campaign.title && (
                                        <div className="campaign-queue-context__meta text-muted mb-2">
                                            {campaign.title}
                                        </div>
                                    )}
                                    <div className="d-flex flex-wrap gap-2">
                                        <span
                                            className={`badge campaign-queue-type-badge ${
                                                isSms
                                                    ? 'bg-success bg-opacity-10 text-success'
                                                    : 'bg-primary bg-opacity-10 text-primary'
                                            }`}
                                        >
                                            <i
                                                className={`bi ${isSms ? 'bi-chat-dots' : 'bi-envelope'} me-1`}
                                            ></i>
                                            {campaign.type}
                                        </span>
                                        <span className="badge bg-light text-dark border campaign-queue-type-badge">
                                            {toProperCase(campaign.category)}
                                        </span>
                                        <CampaignStatusBadge
                                            status={campaign.status}
                                            statusCode={campaign.statusCode}
                                        />
                                    </div>
                                </div>
                                <div className="text-md-end">
                                    <div className="text-muted small mb-1">Campaign ID</div>
                                    <div className="font-monospace small text-break">{campaign.id}</div>
                                </div>
                            </div>
                        </div>

                        <div className="card shadow-sm border-0 campaign-queue-table-card">
                            <div className="card-body p-0">
                                <div className="d-flex align-items-center flex-wrap gap-1 p-3 border-bottom">
                                    <i
                                        className={`bi ${
                                            isSms ? 'bi-chat-dots' : 'bi-envelope-open'
                                        } text-primary me-1`}
                                    ></i>
                                    <h5 className="card-title mb-0" style={{ color: '#012970' }}>
                                        {isSms ? 'SMS Message' : 'Email Content'}
                                    </h5>
                                </div>

                                {isSms ? (
                                    <div className="p-3">
                                        <SmsPreview message={campaign.contentPath} />
                                    </div>
                                ) : (
                                    <EmailPreview
                                        htmlContent={campaign.contentPath}
                                        title={campaign.title}
                                    />
                                )}
                            </div>
                        </div>
                    </>
                )
            )}
        </div>
    );
}

export default CampaignPreview;
